import React from 'react';
import LogoTitle from '../../assets/svg/logo-title.svg';
import LanguageSelector from '../languageSelector/LanguageSelector';

export const NoAuth = (): JSX.Element => {
  return (
    <div
      className="w-full  fixed top-0 h-[60px] flex justify-between items-center z-20
    bg-neutral-98

  "
    >
      <div className="max-w-[1440px] mx-auto flex justify-between 2xl:min-w-[1230px] lg:min-w-[900px] md:min-w-[700px] w-full ">
        <div className="pl-[24px] bg-transparent ">
          <img src={LogoTitle} className="h-6 " alt="Jaam" />
        </div>
        <div className="pr-6 bg-transparent text-end">
          <LanguageSelector />
        </div>
      </div>
    </div>
  );
};
export default NoAuth;
